import { createFileRoute } from '@tanstack/react-router';
import { ReactFlowProvider } from '@xyflow/react';

import { LoomCommandRegistryProvider } from '@/components/features/loom/providers/LoomCommandRegistryProvider';
import { LoomStoreProvider } from '@/components/features/loom/providers/LoomStoreProvider';
import { TemplateCanvasWithChat } from '@/components/features/loom/templates/TemplateCanvasWithChat';

export const Route = createFileRoute('/_protected/t/$tenantId/loom/templates/new/')({
  component: RouteComponent,
  ssr: false,
});

function RouteComponent() {
  return (
    <ReactFlowProvider>
      <LoomStoreProvider initialState={{ toolboxOpen: true }}>
        <LoomCommandRegistryProvider>
          <TemplateCanvasWithChat />
        </LoomCommandRegistryProvider>
      </LoomStoreProvider>
    </ReactFlowProvider>
  );
}
